import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { setControllerFullscreenStatus } from 'client-portal/utils/widget';
import Route from '@ember/routing/route';

export default class ContactWidgetRoute extends Route {
  @service analytics;
  @service store;
  @service currentPractice;
  @service router;
  @service session;
  @service message;
  @service fastboot;
  @service prescreener;

  queryParams = {
    clinicianId: { refreshModel: true },
    appearance: { refreshModel: true },
    locale: { refreshModel: false },
  };

  @action
  reveal() {
    this.#trackOpened();
  }

  beforeModel() {
    super.beforeModel(...arguments);

    if (
      !this.currentPractice.get('practiceContactForm') &&
      !this.currentPractice.get('monarchContactForm')
    ) {
      this.router.transitionTo('home');
    }

    this.enablePrescreenerOnCurrentClient();
  }

  async model({ clinicianId }, _transition) {
    let clinician = clinicianId ? await this.store.findRecord('clinician', clinicianId) : null;
    let { clinicianReferral } = this.session;

    let client = this.store.createRecord('prospective-client', {
      emails: [this.store.createRecord('email', { prospectiveClient: true })],
      phones: [
        this.store.createRecord('phone', {
          prospectiveClient: true,
          leaveVoiceMessage: true,
          leaveTextMessage: true,
        }),
      ],
      globalMonarchChannelName: this.session.channel,
      clinician,
      ...(clinicianReferral ? { clinicianReferral } : {}),
    });

    await this.prescreener.loadGlobalMonarchChannel();

    if (this.prescreener.canLoadPrescreener) {
      await this.prescreener.preloadClinicians();
      await this.prescreener.updatePrescreenerModels();
    }

    return { client, clinician };
  }

  setupController(controller) {
    super.setupController(...arguments);
    setControllerFullscreenStatus(controller, false);
  }

  activate(_transition) {
    super.activate(_transition);
    this.message.registerTarget(this);
  }

  deactivate(_transition) {
    super.deactivate(_transition);
    this.message.unregisterTarget();
    this.disablePrescreenerOnCurrentClient();
  }

  afterModel(_resolvedModel, _transition) {
    super.afterModel(_resolvedModel, _transition);
    if (!this.fastboot.isFastBoot && window.self === window.top) {
      this.#trackOpened();
    }
  }

  enablePrescreenerOnCurrentClient() {
    if (this.session.currentClient) {
      this.prescreener.showPrescreenerWithClientAccess = true;
    }
  }

  disablePrescreenerOnCurrentClient() {
    this.prescreener.showPrescreenerWithClientAccess = false;
  }

  #trackOpened() {
    this.analytics.trackAnonymously('Contact Form Widget Opened', {
      Object: 'Contact Form Widget',
      Action: 'Opened',
      'site_name': this.session.siteName,
    });
  }
}
